angular.module('app').factory('TraceClassService', function () {
    let fac = {
        traceClass: traceClass,
        subTraceClass: subTraceClass
    };
    function traceClass(item) {
        let messageType = item.MessageType;
        // raw
        if (messageType === 'raw-message') {
            return 'raw';
        }
        // verdict
        let verdictResult = item.VerdictResult;
        switch (verdictResult) {
            case 'verdict-fail':
            case 'verdict-fail-reasons':
            case 'verdict-clearing-fail':
            case 'verdict-clearing-fail-reasons':
            case 'reason-fail':
                return 'fail';
            case 'verdict-pass':
            case 'verdict-pass-reasons':
            case 'verdict-clearing-pass':
            case 'verdict-clearing-pass-reasons':
            case 'reason-pass':
                return 'pass';
            case 'verdict-suspended':
            case 'verdict-suspended-actions':
                return 'suspended';
            case 'request-certhost':
            case 'response-certhost':
                return 'certhost';
        }
        // neither raw nor verdict
        return 'text-dark';
    }
    function subTraceClass(item) {
        if (item.skipSubTraceClassCalculation) {
            return '';
        }
        let messageType = item.MessageType;
        if (_.isNil(messageType)) {
            // Due to the way the ya-treeview is set up in the html, we call this method
            // after the class has alreadt been set in a call to traceClass.
            // In this instance the object passed in is a child of the TraceTreeViewModel pass into traceClass
            // but has nothing set in the MessageType property. In this case we dont want to change
            // the class set in traceClass so we return ''
            // This is a symptom of something not being correct in the object structure/design and should be investigated and fixed
            return '';
        }
        switch (messageType) {
            case 'verdict-fail':
            case 'verdict-fail-reasons':
            case 'verdict-clearing-fail':
            case 'verdict-clearing-fail-reasons':
            case 'reason-fail':
                return 'fail';
            case 'verdict-pass':
            case 'verdict-pass-reasons':
            case 'verdict-clearing-pass':
            case 'verdict-clearing-pass-reasons':
            case 'reason-pass':
                return 'pass';
            case 'request-certhost':
            case 'response-certhost':
                return 'certhost';
            case 'raw-message':
                return 'raw';
            case 'highlighted-information':
                return 'highlighted-information';
        }
        // neither raw nor verdict
        return 'text-dark';
    }
    return fac;
});
